import { FC } from "react";
import { TGetCompanyDto } from "@/api/services/main/company/dtos/get-company.dto";
import { InnerBox } from "@/components/elements/InnerBox";
import { Grid } from "@mui/material";
import { ItemInfo } from "@/components/commons/ItemInfo";
import { CompanyFormTitle } from "@/features/company/components/company-info/CompanyFormTitle";

type TCompanyDetailProps = {
  defaultValues?: Partial<TGetCompanyDto>;
};

export const CompanyAdditionalDetailInfo: FC<TCompanyDetailProps> = ({ defaultValues }) => {
  return (
    <InnerBox title={<CompanyFormTitle text="その他の情報" />} showDivider={false}>
      <Grid
        container
        sx={{
          marginTop: "24px",
        }}
      >
        <Grid item xs={12}>
          <ItemInfo label="メモ" value={defaultValues?.note} isShowDivider={false} type="textArea" />
        </Grid>
      </Grid>
    </InnerBox>
  );
};
